'use client';

import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; 

export const errorModalSlice = createSlice({
  name: 'errorModal',
  initialState: {
    isOpenErrorModal: false,
  },
  reducers: {
    setIsOpenErrorModal: (state, action) => {
      state.isOpenErrorModal = action.payload;
    }
  },
});

export const { setIsOpenErrorModal } = errorModalSlice.actions;

const persistConfig = {
    key: 'error',
    storage: storage
}

export default persistReducer(persistConfig, errorModalSlice.reducer);
